// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"64":"623e8b20","215":"8885fa1a","221":"2720e8dd","237":"69cc5940","281":"efed47d8","385":"46fe323d","464":"d552a351","540":"46fe323d","570":"b271849d","666":"25e8b7d6","673":"05265c03","730":"d552a351","733":"742280d8","754":"d40d2cfe","764":"d552a351"}[chunkId] + ".chunk.css";
};